module.exports = __webpack_public_path__ + "7ba84a909d715d508737fca1a3999460.jpg";